import { render, staticRenderFns } from "./WBtnImport.vue?vue&type=template&id=594fa4ec&scoped=true&"
import script from "./WBtnImport.vue?vue&type=script&lang=js&"
export * from "./WBtnImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594fa4ec",
  null
  
)

export default component.exports